MST.lang['jp'] = {
	'timeframe' : 'Timeframe',
	'2D' : '日中',
	'1D' : '1日',
	'1W' : '1週間',
	'1M' : '1ヶ月',
	'3M' : '3ヶ月',
	'6M' : '6ヶ月',
	'YTD' : 'YTD',
	'1Y' : '1年',
	'3Y' : '3年',
	'5Y' : '5年',
	'10Y' : '10年',
	'ALL' : '設定来',
	'charttype' : 'Charttype',
	'mountain' : 'マウンテンチャート',
	'line' : 'ラインチャート',
	'candle' : 'ローソクチャート',
	'open' : '始値',
	'high' : '高値',
	'low' : '安値',
	// 'close' : '終値',
	'close' : '基準価額',
	'dividend' : '分配金込み価額',
	// 'volume' : '出来高',
	'volume' : '純資産(百万円)',
	'transit' : '転換線',
	'base' : '基準線',
	'precede1' : '先行1',
	'precede2' : '先行2',
	'late' : '遅行',
	'stockPrice' : '株価',
	'period' : '期間',
	'emaShort': '短期',
	'emaLong' : '長期',
	'signal': 'シグナル',
	'later' : '遅行',
	'MA' : '移動平均',
	'BollingerBand' : 'ボリンジャーバンド',
	'MACD' : 'MACD',
	'Kairi' : '移動平均乖離率',
	'Momentum' : 'モメンタム',
	'Ichimoku' : '一目均衡',
	'SRV' : 'ストキャスティクス',
	'indicators' : 'テクニカル',
	'benchmarks' : 'ファンドや指数と比較',
	'add' : '追加',
	'reset' : 'リセット',
	'benchmark_help' : "このテキストボックスにファンドコードを記入し、 [追加]ボタンをクリックすると、現在の基準価格傾向と比較することができます。",
	'noData_simple' : 'チャートはありません',
	'loadFail_simple' : 'データのロードに失敗しました。後でもう一度試してください。',
	'update_browser' : 'ご利用のWebブラウザのバージョンが古いため、アップグレードすることを強くおすすめ致します。',
	
	'timeformat_MMM' : ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
	'timeformat_MMMM' : ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
	'timeformat_WWW' : ['日', '月', '火', '水', '木', '金', '土'],
	'timeformat_WWWW' : ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
};

MST.timeformat['jp'] = {
	'H' : 'H',
	'mdHM' : 'MM/dd HH:mm',
	'md' : 'MM/dd',
	'mdH' : 'MM/dd HH:mm',
	'ymd' : 'yyyy/MM/dd',
	'ymdW' : 'yyyy/MM/dd（WWW）',
	'ym' : 'yyyy/MM',
	'y' : 'yyyy',
	'ymdHM' : 'yyyy/MM/dd HH:mm'
};
